import { AnalyticsEvent } from "./AnalyticsEvent.js";
import type {
    AnalyticsEventType } from "./AnalyticsEventType.js";
import {
    ANALYTICS_NUDGE_PREFIX,
} from "./AnalyticsEventType.js";
import type { NudgeType } from "../nudge/NudgeType.js";


function generateEventAction(
    type: AnalyticsEventType,
    nudgeType: NudgeType,
): string {
    return `${type.getEventCategory()}_${nudgeType.getID()}`;
}


export class NudgeAnalyticsEvent extends AnalyticsEvent {
    constructor(
        type: AnalyticsEventType,
        nudgeType: NudgeType,
    ) {
        super(type, generateEventAction(type, nudgeType));
        if (type.getPrefix() !== ANALYTICS_NUDGE_PREFIX)
            throw new Error(type.getEventCategory() + " is not a nudge event");
    }
}
